var USER_FLOWS = {
    campaign: 'prototype-player',
    source: 'other',
    medium: 'web-app',
    term: 'player',
    content: 'userflows',
};
var EDIT_PROJECT = {
    campaign: 'prototype-player',
    source: 'other',
    medium: 'web-app',
    term: 'player',
    content: 'edit-project',
};
export { USER_FLOWS, EDIT_PROJECT };
